export const BODY_CENTER_X = 50;
export const CENTER_TOLERANCE = 6;
/** Limbs must sit outside this corridor; otherwise trunk zones win. */
export const LIMB_CENTER_EXCLUSION = 11;

/** SVG figure image placement (viewBox 0 0 100 100). */
export const FIGURE_LAYOUT = { x: 0, y: -4, width: 100, height: 110 };

export const ANATOMICAL_ZONES = [
  {
    id: 'head_neck',
    label: 'Head/Neck',
    code: 'Cervical_C7',
    views: ['front', 'back'],
    bounds: { xMin: 34, xMax: 66, yMin: 0, yMax: 18 },
    lateral: false,
  },
  {
    id: 'upper_trunk',
    label: 'Upper Chest / Upper Back',
    codeByView: { front: 'Thoracic_T6', back: 'Thoracic_T6' },
    views: ['front', 'back'],
    bounds: { xMin: 30, xMax: 70, yMin: 18, yMax: 38 },
    lateral: true,
  },
  {
    id: 'lower_trunk',
    label: 'Abdomen / Lower Back',
    codeByView: { front: 'Abdominal_Region', back: 'Lumbar_Region_L4' },
    views: ['front', 'back'],
    bounds: { xMin: 30, xMax: 70, yMin: 38, yMax: 53 },
    lateral: true,
  },
  {
    id: 'pelvis_hips',
    label: 'Pelvis/Hips',
    code: 'Sacral_S1',
    views: ['front', 'back'],
    bounds: { xMin: 28, xMax: 72, yMin: 53, yMax: 63 },
    lateral: true,
  },
  {
    id: 'upper_arm',
    label: 'Upper Arm',
    code: 'Upper_Arm_Region',
    views: ['front', 'back'],
    bounds: { xMin: 14, xMax: 86, yMin: 22, yMax: 40 },
    lateral: true,
  },
  {
    id: 'forearm',
    label: 'Forearm',
    code: 'Forearm_Region',
    views: ['front', 'back'],
    bounds: { xMin: 10, xMax: 90, yMin: 40, yMax: 56 },
    lateral: true,
  },
  {
    id: 'hand',
    label: 'Hand',
    code: 'Hand_Region',
    views: ['front', 'back'],
    bounds: { xMin: 7, xMax: 93, yMin: 56, yMax: 68 },
    lateral: true,
  },
  {
    id: 'thigh',
    label: 'Thigh',
    code: 'Thigh_Region',
    views: ['front', 'back'],
    bounds: { xMin: 30, xMax: 70, yMin: 63, yMax: 76 },
    lateral: true,
  },
  {
    id: 'knee',
    label: 'Knee',
    codeByView: { front: 'Knee_Anterior_Region', back: 'Knee_Posterior_Region' },
    views: ['front', 'back'],
    bounds: { xMin: 30, xMax: 70, yMin: 76, yMax: 83 },
    lateral: true,
  },
  {
    id: 'calf',
    label: 'Lower Leg',
    codeByView: { front: 'Shin_Region', back: 'Calf_Region' },
    views: ['front', 'back'],
    bounds: { xMin: 31, xMax: 69, yMin: 83, yMax: 92 },
    lateral: true,
  },
  {
    id: 'foot',
    label: 'Foot',
    code: 'Foot_Region',
    views: ['front', 'back'],
    bounds: { xMin: 28, xMax: 72, yMin: 92, yMax: 100 },
    lateral: true,
  },
];

